module.exports = {
  container: 'gathering/list/container',
  createButton: 'gathering/list/createButton',
  item: {
    detailsButton: name => `gathering/list/item/${name}/detailsButton`
  },
  search: 'gathering/list/search'
}
